import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '../services/firebase';

const ERROR_MESSAGES = {
  'auth/invalid-custom-token': 'Sign-in link has expired. Please try again.',
  'auth/custom-token-mismatch': 'Sign-in link is invalid. Please try again.',
  'auth/network-request-failed': 'Network error. Check your connection and try again.',
};

/**
 * Auth callback page — receives custom token from LinksID and signs in.
 * Route: /auth/callback?token=<custom_token>
 */
export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const retryUrl = 'https://linksid.colewinds-dev.com/auth/login?return_url='
    + encodeURIComponent(window.location.origin + '/auth/callback');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('No authentication token received.');
      return;
    }

    signInWithCustomToken(auth, token)
      .then((cred) => {
        console.log('[LinksID] Signed in via LinksID custom token');
        localStorage.setItem('authToken', cred.user.accessToken);
        navigate('/', { replace: true });
      })
      .catch((err) => {
        console.error('[LinksID] Custom token sign-in failed:', err);
        setError(ERROR_MESSAGES[err.code] || 'Sign-in failed. Please try again.');
      });
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="bg-surface border border-status-error/50 rounded-lg p-6 max-w-md text-center">
          <h2 className="text-lg font-bold text-status-error mb-2">Sign-in Failed</h2>
          <p className="text-text-secondary text-sm mb-4">{error}</p>
          <div className="flex gap-3 justify-center">
            <button
              onClick={() => window.location.href = retryUrl}
              className="bg-primary hover:bg-primary-light text-white py-2 px-4 rounded text-sm font-medium transition-colors"
            >
              Try Again
            </button>
            <button
              onClick={() => navigate('/', { replace: true })}
              className="bg-surface-light hover:bg-border text-text-primary py-2 px-4 rounded text-sm transition-colors"
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-text-secondary">Signing you in with LinksID...</p>
      </div>
    </div>
  );
}
